import React from "preact";

function TrashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#333"
        d="M6.249 3.632h-.13c.071 0 .13-.059.13-.13v.13h4.971v-.13c0 .071.06.13.131.13h-.13v1.177h1.177V3.501c0-.577-.47-1.046-1.047-1.046H6.118c-.577 0-1.046.469-1.046 1.046V4.81h1.177V3.632zm8.242 1.177H2.978a.523.523 0 00-.523.524v.523c0 .072.059.13.13.13h.989l.404 8.553c.026.558.487.998 1.044.998h7.425c.559 0 1.019-.438 1.045-.998l.404-8.552h.987c.072 0 .131-.06.131-.131v-.523a.523.523 0 00-.523-.524zm-2.17 9.55H5.148l-.395-8.372h7.964l-.396 8.373z"
      ></path>
    </svg>
  );
}

export default TrashIcon;
